export const enum MutationNames {
  updatePatients = 'PATIENT_UPDATE_PATIENTS',
}

export const enum ActionNames {
  getPatients = 'PATIENT_GET_PATIENTS',
  getPatient = 'PATIENT_GET_PATIENT',
}

export const enum GetterNames {
  patients = 'PATIENT_PATIENTS',
  activePatients = 'PATIENT_ACTIVE_PATIENTS',
  patientById = 'PATIENT_PATIENT_BY_ID',
  patientNameMapById = 'PATIENT_PATIENT_NAME_MAP_BY_ID',
  patientOrderedByFullName = 'PATIENT_PATIENT_ORDERED_BY_FULL_NAME',
}
